import { NumberInput as ChakraNumberInput, NumberInputRootProps } from '@chakra-ui/react/number-input'
import * as React from 'react'

export const NumberInputRoot = React.forwardRef(function NumberInput(
  props: NumberInputRootProps & {
    withIncrements?: boolean
  },
  ref: React.Ref<HTMLDivElement>,
) {
  const { children, withIncrements = false, ...rest } = props
  return (
    <ChakraNumberInput.Root ref={ref} variant="outline" {...rest}>
      {children}
      {withIncrements && (
        <ChakraNumberInput.Control>
          <ChakraNumberInput.IncrementTrigger />
          <ChakraNumberInput.DecrementTrigger />
        </ChakraNumberInput.Control>
      )}
    </ChakraNumberInput.Root>
  )
})

export const NumberInputField = ChakraNumberInput.Input
export const NumberInputScrubber = ChakraNumberInput.Scrubber
export const NumberInputLabel = ChakraNumberInput.Label
